export default __webpack_public_path__ + "static/media/monocle.9bd49f12.png";